import React, { createContext, useContext, useReducer } from "react";
import { IProjectListState, initialProjectListState } from "./ProjectList/ProjectListState";
import ProjectListReducer from "./ProjectList/ProjectsListReducer";
import { IProjectModalState, initialProjectModalState } from "./ProjectModal/ProjectModalState";
import { IProjectJobsStatusModalState, initialProjectJobsStatusModalState } from "./ProjectJobsStatusModal/ProjectJobsStatusModalState";
import { ProjectModalReducer } from "./ProjectModal/ProjectModalReducer";
import { ProjectJobsStatusModalReducer } from "./ProjectJobsStatusModal/ProjectJobsStatusModalReducer";
import { IUserAuthState, initialUserAuthState } from "./UserAuth/UserAuthState";
import { UserAuthReducer } from "./UserAuth/UserAuthReducer";

export type State = {
  projectList: IProjectListState;
  projectModal: IProjectModalState;
  projectJobsStatusModal: IProjectJobsStatusModalState;
  userAuth: IUserAuthState;
};

type Context = {
  state: State;
  dispatch: (action: any, payload?: any) => any;
};

const initialState: State = {
  projectList: initialProjectListState,
  projectModal: initialProjectModalState,
  projectJobsStatusModal: initialProjectJobsStatusModalState,
  userAuth: initialUserAuthState,
};

const combineReducers = (slices: any) => (prevState: any, action: any) =>
  Object.keys(slices).reduce(
    (nextState, nextProp) => ({
      ...nextState,
      [nextProp]: slices[nextProp](prevState[nextProp], action),
    }),
    prevState
  );

const rootReducer = combineReducers({
  projectList: ProjectListReducer,
  projectModal: ProjectModalReducer,
  projectJobsStatusModal: ProjectJobsStatusModalReducer,
  userAuth: UserAuthReducer,
});

export const StateContext = createContext<Context>({
  state: initialState,
  dispatch: () => initialState,
});

export const StateProvider = ({ children }: any) => {
  const [state, dispatch]: any = useReducer(rootReducer, initialState);

  return (
    <StateContext.Provider value={{ state, dispatch }}>
      {children}
    </StateContext.Provider>
  );
};

export const useAppState = () => useContext(StateContext);

export const useSelector = (callback: any) => {
  const state = { ...useContext(StateContext).state };
  return callback ? callback(state) : state;
};
